import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "../../App.css";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  MenuItem,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CategoryIcon from "@mui/icons-material/Category";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { TableNodata } from "../../components/TableNodata";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import api from "../../api/client";
import { useSnackbar } from "../../providers/SnackbarProvider";
import CustomPagination from "../../components/CustomPagination";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AddSubcategory = () => {
  const tableHeaders = [
    { name: "S.No", align: "center" },
    { name: "Subtopic", align: "left" },
    { name: "Created by", align: "left" },
    { name: "Created Date", align: "left" },
    { name: "Status", align: "left" },
    { name: "Actions", align: "left" },
  ];
  const { showSnackbar } = useSnackbar();
  const location = useLocation();
  const { categoryName, categoryId } = location?.state || {};
  const [showTable, setShowTable] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [addCategory, setAddCategory] = useState(true);
  const [editCategoryId, setEditCategoryId] = useState(null);
  // const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const statuses = ["ACTIVE", "INACTIVE"];
  // Dummy data
  const [categories, setCategories] = useState([]);
  const [count, setCount] = useState(0);

  const schema = Yup.object().shape({
    category: Yup.string().required("Subtopic is required"),
    // institute: Yup.number()
    //   .required("Institute is required")
    //   .typeError("Institute is required"),
  });

  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      category: "",
      // institute: [],
      status: "ACTIVE",
    },
  });

  const handleAdd = () => {
    setAddCategory(true);
    setEditCategoryId(null);
    reset({
      category: "",
      // institute: []
    });
    setOpenForm(true);
  };

  const handleEdit = async (row) => {
    console.log(row);
    try {
      setAddCategory(false);
      setEditCategoryId(row);
      const payload = { subcategory_id: row };
      const res = await api.post("ViewSubCategoryByID", payload);

      if (res?.data?.status === "success") {
        const categoryData = res.data.data;
        reset({
          category: categoryData.subcategory_name,
          // institute: categoryData.institute_id,
          status: categoryData.status,
        });
        setOpenForm(true);
      } else {
        showSnackbar("error", res?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching category:", error);
      showSnackbar("error", error?.response?.data?.message || error?.message || "Failed to fetch subtopic details.");
    }
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    reset();
  };

  const onSubmit = async (data) => {
    console.log(data);
    setSaveLoading(true);
    try {
      const payload = {
        subcategory: data.category,
        category_id: categoryId,
        status: "ACTIVE",
      };
      const updatePayload = {
        subcategory_id: editCategoryId,
        // institute_id: [+selectedInstitutes],
        subcategory_name: data.category,
        status: data.status,
      };
      if (editCategoryId !== null) {
        const res = await api.post("UpdateSubCategoryByID", updatePayload);
        if (res?.data?.status === "success") {
          showSnackbar("success", res?.data?.message);
          setOpenForm(false);
          listSubCategory();
        } else {
          showSnackbar("error", res?.data?.message);
        }
      } else {
        const res = await api.post("AddSubCategory", payload);
        if (res?.data?.status === "success") {
          setOpenForm(false);
          showSnackbar("success", res?.data?.message);
          listSubCategory();
        } else {
          showSnackbar("error", res?.data?.message);
        }
      }
    } catch (e) {
      console.log("Error:", e);
      showSnackbar("error", "Something went wrong");
    } finally {
      setSaveLoading(false);
    }
  };

  const listSubCategory = async () => {
    try {
      const payload = {
        category_id: categoryId,
      };
      const res = await api?.post("ListSubCategoriesWithDetails", payload);
      if (res?.data?.status === "success") {
        setCategories(res?.data?.data || []);
        setCount(res?.data?.count);
      } else {
        showSnackbar("error", res?.data?.message || "Failed to fetch subtopics");
      }
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", error?.response?.data?.message || error?.message || "Failed to fetch subtopics. Please try again.");
    }
  };

  useEffect(() => {
    listSubCategory();
    const timer = setTimeout(() => {
      setShowTable(true);
    }, 200); // 0.2 sec delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      {/* Back Button */}
      <Grid
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#1c97e3",
          gap: "6px",
          cursor: "pointer",
          width: "fit-content",
          transition: "0.2s",
          "&:hover": { color: "#0a73b1" },
          mb: 2,
        }}
        role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.history.back();
              }
            }}
            onClick={() => window.history.back()}
      >
        <ArrowBackIcon sx={{ fontSize: "18px" }} />
        <Typography
          sx={{ fontWeight: 600, fontSize: "14px", color: "inherit" }}
        >
          Back
        </Typography>
      </Grid>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        sx={{ pb: 2 }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
            alignItems: "center",
          }}
        >
          <Box className="icon-box">
            <CategoryIcon className="iconHeading" />
          </Box>
          <Typography sx={{ fontSize: { xs: 20, sm: 28 }, fontWeight: 700, color: "#0a0a0a" }}>
            {categoryName}
          </Typography>
        </Grid>
        <Box display="flex" gap={4} alignItems="center">
          <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            variant="outlined"
            placeholder="Search by Subtopic"
            className="custom-search-field"
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ marginLeft: "6px", marginRight: "2px" }}
                >
                  <SearchIcon sx={{ color: "inherit", fontSize: "18px" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAdd}
            className="gradient-button"
          >
            Add Subtopic
          </Button>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          opacity: showTable ? 1 : 0,
          transform: showTable ? "translateY(0)" : "translateY(40px)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaders.map((header) => (
                <TableCell
                  align={header.align}
                  key={header.name}
                  className="tableHeader"
                >
                  <b>{header.name}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody className="tablebody">
            {categories.length > 0 ? (
              categories.map((item, index) => (
                <TableRow
                  key={item.id}
                  sx={{
                    backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                    "&:hover": { backgroundColor: "#f1f1f1" },
                  }}
                >
                  <TableCell align="center">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.created_by}</TableCell>
                  <TableCell>
                    {dayjs(item.created_at).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "inline-block",
                        px: 2,
                        py: 0.5,
                        borderRadius: "12px",
                        fontWeight: "bold",
                        fontSize: "12px",
                        backgroundColor:
                          item.status === "ACTIVE" ? "#d4edda" : "#f8d7da",
                        color: item.status === "ACTIVE" ? "#155724" : "#721c24",
                        textAlign: "center",
                      }}
                    >
                      {item.status}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      display="flex"
                      justifyContent="left"
                      alignItems="center"
                      gap={2}
                    >
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleEdit(item?.id);
                        }}
                      >
                        <EditIcon color="primary" />
                        <Typography sx={{ fontSize: "12px" }} color="primary">
                          Edit
                        </Typography>
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHeaders?.length} align="center">
                  <TableNodata />
                </TableCell>
              </TableRow>
            )}
          </TableBody>

          {((page === 0 && categories?.length > rowsPerPage - 1) ||
            page !== 0) && (
            <CustomPagination
              page={page}
              setPage={setPage}
              count={count}
              rowsPerPage={rowsPerPage}
              colSpan={tableHeaders?.length}
            />
          )}
        </Table>
      </TableContainer>

      <Dialog
        open={openForm}
        PaperProps={{
          sx: { width: "500px", borderRadius: "12px", p: 2 },
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <CategoryIcon
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              fontSize: "30px",
              top: -20,
              borderRadius: "50%",
              padding: "5px",
            }}
          />
          <DialogTitle
            sx={{ fontWeight: 700, color: "#1976d2", padding: "5px" }}
          >
            {addCategory ? "Add Subtopic" : "Update Subtopic"}
          </DialogTitle>
        </Box>
        <Divider
          sx={{ mt: 2, borderColor: "black", borderBottomWidth: 1, mx: 0 }}
        />
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CategoryIcon
                sx={{ color: "#1976d2", fontSize: "25px", mr: 1 }}
              />
              <Typography sx={{ fontWeight: "bold" }}>
                Subtopic <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
            <Controller
              name="category"
              control={control}
              render={({ field }) => (
                <TextField
                  sx={{ mb: 2 }}
                  {...field}
                  fullWidth
                  placeholder="Enter Subtopic"
                  margin="dense"
                  error={!!errors.category}
                  helperText={errors.category?.message}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[0-9]/g, "");
                  }}
                />
              )}
            />

            {!addCategory && (
              <Grid sx={{ display: "flex", gap: 3 }}>
                {/* Status */}
                <Grid sx={{ width: "100%", mt: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {watch("status") === "ACTIVE" ? (
                      <ToggleOnIcon
                        sx={{
                          color: "#1976d2",
                          fontSize: "25px",
                          mr: 1,
                        }}
                      />
                    ) : (
                      <ToggleOffIcon
                        sx={{
                          color: "grey",
                          fontSize: "25px",
                          mr: 1,
                        }}
                      />
                    )}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Status <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </Box>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} select fullWidth>
                        {/* Placeholder */}
                        <MenuItem
                          value="default"
                          disabled
                          sx={{ color: "grey" }}
                        >
                          Select Status
                        </MenuItem>

                        {/* Options */}
                        {statuses.map((status) => (
                          <MenuItem key={status} value={status}>
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
              </Grid>
            )}
            <DialogActions sx={{ justifyContent: "end", pb: 2, mt: 2 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseForm}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saveLoading}
                sx={{ textTransform: "none" }}
              >
                {saveLoading
                  ? "Saving..."
                  : `${addCategory === true || addCategory === "true" ? "Add" : "Update"} subtopic`}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AddSubcategory;
